import WhyION from "@/components/site/WhyION";
import AboutION from "@/components/site/AboutION";
import ReviewsSplit from "@/components/site/ReviewsSplit";
import PageMeta from "@/components/site/PageMeta";

export default function WhyIONPage() {
  return (
    <main className="pt-24 md:pt-32" data-testid="why-ion-page">
      <PageMeta
        title="Why ION Solar | Installation & Support"
        description="Why Jeremy chose to work with ION Solar: 85,000+ installations across the U.S., professional installation, long-term monitoring, and a 10-year workmanship warranty plus 25-year production guarantee."
      />
      <section className="pb-6 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow">Why ION</div>
          <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#0F382C] max-w-4xl">
            The trusted company behind a personal experience.
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-600">
            I'm your local guide. ION Solar provides the installation, equipment, warranties, and long-term service.
          </p>
        </div>
      </section>
      <WhyION />
      <AboutION />
      <ReviewsSplit />
    </main>
  );
}
